import { Loader2, Save, Trash2, X } from 'lucide-react';

interface UnsavedChangesModalProps {
  onStay: () => void;
  onDiscard: () => void;
  onSave?: () => Promise<void>;
  canSave: boolean;
  isSaving: boolean;
  setIsSaving: (v: boolean) => void;
}

export function UnsavedChangesModal({
  onStay,
  onDiscard,
  onSave,
  canSave,
  isSaving,
  setIsSaving,
}: UnsavedChangesModalProps) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="unsaved-changes-title"
        className="w-[480px] bg-white rounded-xl border border-slate-200 shadow-xl flex flex-col overflow-hidden"
      >
        <div className="px-6 py-3 border-b border-slate-200 bg-slate-50 rounded-t-xl flex-shrink-0">
          <p
            id="unsaved-changes-title"
            className="text-xs font-semibold uppercase tracking-wider text-slate-600"
          >
            Unsaved Changes
          </p>
        </div>
        <div className="px-6 py-5">
          <p className="text-sm text-slate-600">
            You have unsaved changes. Would you like to save before leaving?
          </p>
          <div className="flex gap-2 mt-5 justify-end">
            <button
              onClick={onStay}
              className="flex items-center gap-1.5 px-4 py-2 text-sm font-medium text-slate-600 bg-white border border-slate-200 rounded-lg hover:bg-slate-50 transition-colors"
            >
              <X className="w-4 h-4" />
              Stay
            </button>
            <button
              onClick={onDiscard}
              className="flex items-center gap-1.5 px-4 py-2 text-sm font-medium text-slate-600 bg-white border border-slate-200 rounded-lg hover:bg-slate-50 transition-colors"
            >
              <Trash2 className="w-4 h-4" />
              Discard & Leave
            </button>
            {canSave && onSave && (
              <button
                disabled={isSaving}
                onClick={async () => {
                  setIsSaving(true);
                  try {
                    await onSave();
                  } finally {
                    setIsSaving(false);
                  }
                }}
                className="flex items-center gap-1.5 px-4 py-2 text-sm font-medium text-white bg-[#0014cc] rounded-lg hover:bg-[#0014cc]/90 disabled:opacity-50 transition-colors"
              >
                {isSaving ? (
                  <Loader2 className="w-4 h-4 animate-spin" />
                ) : (
                  <Save className="w-4 h-4" />
                )}
                {isSaving ? 'Saving…' : 'Save & Leave'}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
